import { createApi } from '@reduxjs/toolkit/query/react'
import { ILCHttpResponse } from '@logicalcommander/types'
import { eTableName } from '@logicalcommander/types'
import { ISearch, ISort } from '@logicalcommander/types'
import { createBaseQueryWithErrorHandling } from './baseQueryWithErrorHandling'
import { configManager } from '../../config/configManager'
import { RootState } from '../redux/store'
import { v4 as uuidv4 } from 'uuid'

export enum eExportFormat {
  PDF = 'pdf',
  XLSX = 'xlsx',
}

export interface IExportDataRequest {
  tableName: eTableName
  format: eExportFormat
  search?: ISearch[]
  sortBy?: ISort[]
  columns?: string[]
}

export const exportApi = createApi({
  reducerPath: 'exportApi',
  baseQuery: createBaseQueryWithErrorHandling(`${configManager.api.GATEWAY_URL}/export`, (headers: Headers, { getState }: any) => {
    headers.set('x-request-id', uuidv4())
    const { token, companyToken } = (getState() as RootState).authReducer
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    if (companyToken) {
      headers.set('x-company-token', companyToken)
    }
    return headers
  }),
  endpoints: (builder) => ({
    getExportData: builder.mutation<any[], IExportDataRequest>({
      query: (exportRequest) => ({
        url: '/data',
        method: 'POST',
        body: exportRequest,
      }),
      transformResponse: (rawResult: ILCHttpResponse<any[]>, meta) => {
        return rawResult.data as any[]
      },
    }),
  }),
})

export const { useGetExportDataMutation } = exportApi
